export const destinations = [
  {
    id: 1,
    name: 'Chamonix Mont-Blanc',
    type: 'Station Premium',
    price: 250,
    priceVan: 350,
    distance: 'Depuis Genève Aéroport • 1h15',
    image: 'https://public.readdy.ai/ai/img_res/0ca13d5a5c58e9ab6ab204b1de4e46c0.jpg'
  },
  {
    id: 2,
    name: 'Courchevel 1850',
    type: 'Station Luxe',
    price: 400,
    priceVan: 520,
    distance: 'Depuis Genève Aéroport • 2h30',
    image: 'https://readdy.ai/api/search-image?query=courchevel%20luxury%20ski%20resort%20elegant%20chalets%20snowy%20mountain%20slopes%20upscale%20alpine%20village%20winter%20landscape%20premium%20destination%20blue%20sky%20pristine%20snow&width=640&height=480&seq=courchevel-001&orientation=landscape'
  },
  {
    id: 3,
    name: 'Megève',
    type: 'Station Prestige',
    price: 250,
    priceVan: 350,
    distance: 'Depuis Genève Aéroport • 1h45',
    image: 'https://readdy.ai/api/search-image?query=megeve%20charming%20alpine%20village%20traditional%20chalets%20snowy%20streets%20mountain%20backdrop%20winter%20scenery%20elegant%20ski%20resort%20french%20alps%20pristine%20snow&width=640&height=480&seq=megeve-001&orientation=landscape'
  },
  {
    id: 4,
    name: 'Val d\'Isère',
    type: 'Station Premium',
    price: 470,
    priceVan: 550,
    distance: 'Depuis Genève Aéroport • 2h45',
    image: 'https://readdy.ai/api/search-image?query=val%20disere%20ski%20resort%20dramatic%20mountain%20peaks%20snowy%20slopes%20modern%20alpine%20architecture%20winter%20sports%20destination%20blue%20sky%20pristine%20powder%20snow&width=640&height=480&seq=valdisere-001&orientation=landscape'
  },
  {
    id: 5,
    name: 'Verbier',
    type: 'Station Premium',
    price: 220,
    priceVan: 320,
    distance: 'Depuis Genève Aéroport • 2h00',
    image: 'https://readdy.ai/api/search-image?query=verbier%20swiss%20ski%20resort%20stunning%20mountain%20views%20snowy%20slopes%20alpine%20chalets%20winter%20paradise%20blue%20sky%20pristine%20snow%20covered%20peaks&width=640&height=480&seq=verbier-001&orientation=landscape'
  }
];